import {createStore} from "vuex"
import {$menu} from "dot-framework"
import site from "@/store/site.js"
import braille from '@/store/braille.js'
import canvasPage from '@/store/canvas.js'
import drive from '@/store/drive.js'
import textbook from '@/store/textbook.js'
import easy from "@/store/easy"
import common from "@/store/common"
import auth from "@/store/auth"

export default createStore({
    modules: {
        site,
        $menu,
        canvasPage,
        braille,
        drive,
        textbook,
        easy,
        common,
        auth
    }
})
